import { Button } from "@/components/ui/button";
import { Eye, EyeOff } from "lucide-react";
import { memo, useCallback, type MouseEvent } from "react";

import { activeFiltersSummaryChipVisibilityButtonClassName } from "./activeFiltersSummaryChipButtonClasses";

interface ActiveFiltersSummaryColumnVisibilityToggleProps {
  isVisible: boolean;
  title: string;
  onToggle: () => void;
}

const ActiveFiltersSummaryColumnVisibilityToggleComp = ({
  isVisible,
  title,
  onToggle,
}: ActiveFiltersSummaryColumnVisibilityToggleProps) => {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      onToggle();
    },
    [onToggle],
  );

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={activeFiltersSummaryChipVisibilityButtonClassName}
      title={title}
      onClick={handleClick}
    >
      {isVisible ? <Eye strokeWidth={2} /> : <EyeOff strokeWidth={2} />}
    </Button>
  );
};

export const ActiveFiltersSummaryColumnVisibilityToggle = memo(
  ActiveFiltersSummaryColumnVisibilityToggleComp,
);
